import { RRIInputOption } from '../../form-inputs/interfaces/input-option.interface';
import { RRGarmentFileListModel } from './file-list.model';
import { RRViewerBaseSettings } from './viewer-base-settings.model';

export interface RRVirtualTryonSettingsModel extends RRViewerBaseSettings {
  fileList: RRGarmentFileListModel[];
  mannequinType: 'female' | 'male' | 'custom';
  colorPicker?: boolean;
  colorCheckboxSettings?: RRIInputOption<string>[];
  colorCheckboxModel?: RRIInputOption<string>;
  screenshotHeight?: number;
  screenshotWidth?: number;
  requestSizes?: boolean;
}
